let id = 1;
export const generateId = () => id++;
/* for testing only */
export const resetIdCounter = () => (id = 1);
